// frontend/src/api/backup.js
// Funciones API para la gestión de copias de seguridad.
// AHORA ADAPTADO para trabajar con archivos .zip.

import { request } from './api';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

const readJsonOrText = async (response) => {
  const responseText = await response.text();

  if (!responseText) {
    return {};
  }

  try {
    return JSON.parse(responseText);
  } catch (error) {
    return { message: responseText };
  }
};

/**
 * @function exportBackup
 * @description Solicita al backend la exportación de datos y la devuelve como un Blob .zip.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<Blob>} - Una promesa que resuelve con el archivo de backup .zip como un Blob.
 */
export async function exportBackup(token) {
  const headers = {
    'Authorization': `Bearer ${token}`,
  };
  const response = await fetch(`${API_BASE_URL}/api/backup/export`, { headers });

  if (!response.ok) {
    const errorData = await readJsonOrText(response);
    throw new Error(errorData.message || 'Error al exportar el backup.');
  }
  
  // El backend ahora envía un .zip, por lo que el blob será de tipo 'application/zip'.
  return response.blob();
}

/**
 * @function importBackup
 * @description Sube un archivo de backup .zip para restaurar los datos.
 * @param {FormData} formData - Objeto FormData que contiene el archivo de backup .zip.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<object>} - La respuesta de la API.
 */
export async function importBackup(formData, token) {
  // La lógica de subida no cambia, ya que FormData maneja el tipo de archivo.
  const response = await fetch(`${API_BASE_URL}/api/backup/import`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await readJsonOrText(response);
    throw new Error(errorData.message || 'Error al importar el backup.');
  }
  return readJsonOrText(response);
}

/**
 * @function listBackups
 * @description Obtiene una lista de los backups .zip disponibles en el servidor.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<Array<object>>} - Una promesa que resuelve con un array de objetos de backup.
 */
export async function listBackups(token) {
  return request('/api/backup/list', 'GET', null, token);
}

/**
 * @function restoreFromBackup
 * @description Solicita al backend que restaure desde un archivo de backup .zip específico.
 * @param {string} filename - El nombre del archivo de backup a restaurar.
 * @param {string} token - Token JWT para autorización.
 * @returns {Promise<object>} - La respuesta de la API.
 */
export async function restoreFromBackup(filename, token) {
  return request('/api/backup/restore', 'POST', { filename }, token);
}
